import apiClient, { type ApiError } from './apiClient'
import { API_ENDPOINTS } from './config'
import { extractErrorMessage } from '@/lib/utils/errorHandling'

/**
 * Fetch stored Verifast session step timeline (View Verifast Logs).
 */
export async function getVerifastApplicantLogs(
  applicantId: string | number,
): Promise<unknown[]> {
  try {
    const response = await apiClient.get<unknown[]>(
      API_ENDPOINTS.VERIFAST_LOGS(applicantId),
    )
    return Array.isArray(response.data) ? response.data : []
  } catch (error) {
    throw {
      message: extractErrorMessage(error, 'Failed to load Verifast logs.'),
      status: (error as ApiError).status,
    } as ApiError
  }
}
